"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SelectButton_1 = require("../../SelectButton");
function createLinkControl(_a) {
    var _b = (_a === void 0 ? {} : _a).formatText, formatText = _b === void 0 ? function (_a) {
        var text = _a.text;
        return text;
    } : _b;
    return function linkButtonControlRenderer(_a) {
        var className = _a.className, control = _a.control, error = _a.error, placeholder = _a.placeholder, disabled = _a.disabled, size = _a.size, opened = _a.opened, text = _a.text, option = _a.option, value = _a.value, hasEnterKeyStopPropagation = _a.hasEnterKeyStopPropagation, testId = _a.testId, active = _a.active, actions = _a.actions, focused = _a.focused, onClear = _a.onClear, searchTerm = _a.searchTerm, onSearchTermChange = _a.onSearchTermChange, style = _a.style, rest = __rest(_a, ["className", "control", "error", "placeholder", "disabled", "size", "opened", "text", "option", "value", "hasEnterKeyStopPropagation", "testId", "active", "actions", "focused", "onClear", "searchTerm", "onSearchTermChange", "style"]);
        return (react_1.default.createElement(SelectButton_1.SelectButton, __assign({}, rest, { className: className, "data-selector-id": testId, error: error, placeholder: placeholder, text: formatText({ text: text, option: option, value: value }), disabled: disabled, active: opened, size: size, onBlur: control.onBlur, onFocus: control.onFocus, onClick: control.onClick, onMouseDown: control.onMouseDown, onMouseUp: control.onMouseUp, onMouseEnter: control.onMouseEnter, onMouseLeave: control.onMouseLeave, onKeyDown: control.onKeyDown, onKeyUp: control.onKeyUp, onKeyPress: control.onKeyPress, ref: control.ref, style: control.style })));
    };
}
exports.createLinkControl = createLinkControl;
//# sourceMappingURL=linkButtonControlRenderer.js.map